import airbnb from "../Assets/airbnb.png"
import booking from "../Assets/booking.png"
import expedia from "../Assets/expedia.png"
import google from "../Assets/google.png"
import vrbo from "../Assets/vrbo.png"
const Logos=()=>
{
    let data=[airbnb,booking,expedia,vrbo,google,airbnb,booking,expedia,vrbo,google
    ,booking,expedia,vrbo,google,booking,expedia,vrbo,google,booking,expedia,vrbo,google]
    return(
        <div className="sm:flex sm:justify-center sm:py-[40px] lg:py-[50px] px-[40px] bg-[#F6F6F6] ">
            <div className="slider">
                <div className="slide-track">
                {
                data?.map((e,i)=>
                {
                    return(
                        <div className={`lg:w-[300px] sm:w-[100px] slide`}>
                            <img className="sm:w-[70%]" src={e} key={i}/>
                        </div>
                    )
                })
                
                }
                </div>
            </div>
        </div>
    )
}
export default Logos
